import * as React from 'react';
import Skeleton from 'telstra-ui/components/skeleton/Skeleton';
import TableSkeletonLoader from './table-skeleton-loader';

interface IPageSkeletonSection {
    width?: number;
    height?: number;
    align?: string;
    component?: string;
}

interface IPageSkeletonScreen {
    name?: string;
    layout?: string;
    sections?: IPageSkeletonSection[];
}

interface IPageSkeletonProps {
    page?: IPageSkeletonScreen;
}

const PageSkeletonLoader: React.FC<IPageSkeletonProps> = (props: IPageSkeletonProps) => {

    const createSkeleton = (el) => {
        return (
            <div className={'tc-st-skeleton-section skeleton-align-' + el.align}>
                <Skeleton width={el.width} height={el.height} />
            </div>
        )
    }

    const getComponentSkeleton = (el) => {
        if (el.component === 'table') {
            return (
                <TableSkeletonLoader type={el.type} />
            )
        }
    }

    const cretePageSkeleton = (el) => {
        if (el.sections && el.sections.length > 0) {
            return (
                <div className={'tc-st-' + el.layout + '-view'}>
                    {el.sections.map((item) => cretePageSkeleton(item))}
                </div>
            )
        } else if (el.component && el.component !== '') {
            return getComponentSkeleton(el);
        } else {
            return createSkeleton(el);
        }
    }

    return (
        <div className="tc-st-page-skeleton-container">
               {cretePageSkeleton(props.page)}
        </div>
    )
}

export default PageSkeletonLoader;
